import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import LoadAllRoute from "routes/LoadAllRoute";
import "./assets/scss/theme.scss";
// const queryClient = new QueryClient();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App = props => {
  return (
    <React.Fragment>
      <QueryClientProvider client={queryClient}>
        <LoadAllRoute />
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      </QueryClientProvider>
    </React.Fragment>
  );
};

export default App;
